<!-- used to add emails in whitelist that can skip further spam checks, and can send or recieve without any blockage
component used in EmailDomainList.vue
In (UI) System Settings-> WhiteList/BlackList
-->
<template>
  <!-- <v-col class="containerMinHeightinner pa-0 mx-0 mb-0 mt-7">
    <v-row class="rightDashboardContainer mx-auto my-5">
  <v-col class="pa-0 mt-5">-->
  <div>
    <x-accordian title="Whitelist Items" :defaultState="true">
      <v-row no-gutters slot="accordian_content">
        <v-col px-0 py-0 class="orgDataTables">
          <v-row no-gutters>
            <x-table
              :columns="columns"
              :updateTableSize="updateTableRowCountW"
              pageSizeOption="OPTION_2"
              :loading="loadingW"
              :tableRows="
                preferenceServiceHelper.filterPreference(rowsDataWhite)
              "
              :paginationData="{
                pageSize: pageSizeW,
                pageNumber: pageNumberW,
                totalRecords: totalRecordsW,
                setPage: setPageW
              }"
            >
              <template slot="table-top-right">
                <v-text-field
                  class="search-text w-70"
                  v-model="searchWhiteListEmail"
                  placeholder="Search"
                  clearable
                  @click:clear="clearSearch"
                  @keydown="searchFunction(1)"
                >
                  <v-icon
                    slot="append"
                    color="#58E2C2"
                    v-if="
                      searchWhiteListEmail === '' ||
                        searchWhiteListEmail === null
                    "
                    >search</v-icon
                  >
                </v-text-field>
              </template>
              <template slot="table_item" slot-scope="props">
                <tr v-for="item in props.tableRows" :key="item.id">
                  <td width="40%">
                    <span class="wrap-text">
                      {{
                        preferenceServiceHelper.checkEmailOrDomain(
                          item,
                          'emailOrDomain',
                          'value'
                        )
                      }}
                    </span>
                  </td>
                  <td width="40%">
                    {{
                      titleCase(
                        preferenceServiceHelper.checkEmailOrDomain(
                          item,
                          'emailOrDomain',
                          'meta_data'
                        )
                      )
                    }}
                  </td>
                  <td width="5%">
                    <x-button
                      class="white--text w-auto"
                      color="#FF4F4F"
                      buttonText="Remove"
                      @click="() => openConfirmBox('remove', item)"
                    />
                  </td>
                </tr>
              </template>
            </x-table>
          </v-row>
          <AddWhiteListEmailOrDomain
            :addHead="addHead"
            :option="listTypeOptions"
            :clear="addClear"
            :selectedType="'email'"
            @dataSubmit="addItem($event, $preference.ORG_WHITELIST)"
          />
          <v-row>
            <v-col v-if="!initialLoading">
              <v-row>
                <v-col>
                  <h3>Additional whitelist settings</h3>
                </v-col>
              </v-row>
              <label>
                Whitelisted email addresses which have authenticated DNS will be
                excluded from rigorous spam checks.
              </label>
              <v-row>
                <v-col class="py-1 pb-3">
                  <Checkbox
                    v-model="validateWhiteList"
                    title="Validate whitelists"
                    theme="light"
                  ></Checkbox>
                </v-col>
              </v-row>
              <label>
                If selected, then all whitelists are only considered for senders
                that can be validated using SPF or DKIM.
                <p>This applies to both organization and user whitelists.</p>
              </label>
              <v-row>
                <v-col class="py-1 pb-3">
                  <Checkbox
                    v-model="enableUserWhiteList"
                    title="Enable user whitelists"
                    theme="light"
                  ></Checkbox>
                </v-col>
              </v-row>
              <label>
                If selected, then senders present in user whitelists will skip
                spam checks.
              </label>
              <v-row>
                <v-col class="text-right">
                  <x-button
                    outline
                    color="#58e2c2"
                    @click="getSettings"
                    buttonText="Reset"
                  />
                  <x-button
                    color="#58e2c2"
                    @click="openConfirmBox('save')"
                    buttonText="Save Settings"
                    class="ml-2"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col sm="10" v-else>
              <v-skeleton-loader
                type="article"
                :loading="true"
                class="ml-auto"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </x-accordian>

    <x-dialog
      :dialogState="confirmDialogueVar"
      :dialogTitle="dialogTitle"
      :dialogText="dialogText"
      :confirmDialog="true"
      @toggleModal="closeConfirmBox"
      :actions="{
        show: true,
        secondaryButtonFunction: closeConfirmBox,
        primaryButtonFunction: confirmFor === 'save' ? saveSetting : removeItem,
        primaryButtonShow: true,
        secondaryButtonText: cancelText,
        primaryButtonText: successText
      }"
    ></x-dialog>
  </div>
</template>

<script>
const debounceTimeInMilliseconds = 800;
import AddWhiteListEmailOrDomain from '@/components/Common/AddWhiteListEmailOrDomain.vue';
import PreferencesService from '@/services/PreferencesService';
import Checkbox from '@/components/Common/Checkbox';
import PreferenceHelper from '@/helpers/PreferenceHelper';
import { getCustomTableColumn } from '@/helpers/TableHelpers';
let debounce = require('lodash.debounce');
export default {
  components: {
    AddWhiteListEmailOrDomain,
    Checkbox
  },
  data() {
    return {
      whiteListDetail: true,
      listTypeOptions: [
        { key: 'email', value: 'Email' },
        { key: 'domain', value: 'Domain' }
      ],
      columns: this.copyArray([
        ...getCustomTableColumn(['whiteListed', 'Type', 'blank'])
      ]),
      totalRecordsW: 0,
      pageSizeW: 5,
      pageNumberW: 1,
      addHead: 'Add Whitelist Item',
      loadingW: false,
      rowsDataWhite: [],
      searchWhiteListEmail: '',
      enableUserWhiteList: false,
      validateWhiteList: false,
      settingId: '',
      confirmFor: '',
      confirmDialogueVar: false,
      dialogTitle: '',
      dialogText: '',
      cancelText: '',
      successText: '',
      removeItemObj: null,
      preferenceServiceHelper: null,
      initialLoading: false,
      addClear: false
    };
  },
  created() {
    this.preferenceServiceHelper = new PreferenceHelper();
  },
  mounted() {
    this.getListData(true);
    this.getSettings();
  },
  methods: {
    /**
     * to get the whitelist data
     * @param {Boolean} initial
     */
    async getListData(initial) {
      if (initial) {
        this.pageNumberW = 1;
        this.totalRecordsW = 0;
        this.pageSizeW = 5;
        this.initialLoading = true;
      }
      let paging = {
        pageable: true,
        pageNumber: this.pageNumberW,
        size: this.pageSizeW
      };
      this.rowsDataWhite = [];
      this.loadingW = true;
      try {
        let respWhiteList = await PreferencesService.getPreferencesByPreferenceKey(
          this.$preference.ORG_WHITELIST,
          paging
        );
        this.updateListData(respWhiteList);
        this.initialLoading = false;
      } catch (err) {
        this.loadingW = false;
        this.snackbar('error', err);
        this.initialLoading = false;
      }
    },
    /**
     * to update whitelist data
     * @param {Object} listResponse
     */
    async updateListData(listResponse) {
      let response = this.parseResponse(listResponse);
      if (response !== false) {
        this.totalRecordsW = response[0].totalResults;
        this.rowsDataWhite = response[0].results;
      } else {
        this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
      }
      this.loadingW = false;
    },
    /**
     * to add new whitelist item
     * @param {Object} val
     */
    async addItem(val) {
      let reqObject = {};
      this.addClear = false;
      val.category === 'email'
        ? (reqObject = this.preferenceServiceHelper.createPreferenceBody(
            'email',
            { value: val.value },
            'emailOrDomain'
          ))
        : (reqObject = this.preferenceServiceHelper.createPreferenceBody(
            'domain',
            { value: val.value },
            'emailOrDomain'
          ));
      try {
        await PreferencesService.addPreference(
          this.$preference.ORG_WHITELIST,
          reqObject
        );
        val.category === 'email'
          ? this.snackbar('success', this.$message.EMAIL_ADDED_SUCCESS)
          : this.snackbar('success', this.$message.DOMAIN_ADDED_SUCCESS);
        this.getListData(false);
        this.addClear = true;
      } catch (err) {
        this.snackbar('error', err);
        this.addClear = true;
      }
    },
    /**
     * updates the table rows size
     * @param {Number} val
     */
    updateTableRowCountW(val) {
      this.pageSizeW = val;
      this.setPageW(1);
    },
    /**
     * set table page
     * @param {Number} page
     */
    setPageW(page) {
      this.pageNumberW = page;
      if (!this.searchWhiteListEmail || this.searchWhiteListEmail === '') {
        this.getListData(false);
      } else {
        this.searchFunction(this.pageNumberW);
      }
    },
    // clear search bar
    clearSearch() {
      this.searchWhiteListEmail = '';
      this.pageNumberW = 1;
      this.totalRecordsW = 0;
      this.getListData();
    },
    /**
     * to search data
     * @param {Number} pageNumber
     */
    searchFunction: debounce(function(pageNumber) {
      if (this.searchWhiteListEmail === null) {
        this.searchWhiteListEmail = '';
      }
      if (this.searchWhiteListEmail === '') {
        this.pageNumberW = 1;
        this.totalRecordsW = 0;
        this.getListData();
      } else {
        this.searchItem(pageNumber);
      }
    }, debounceTimeInMilliseconds),
    async searchItem(pageNumber) {
      //search email list function
      let paging = {
        pageable: true,
        pageNumber: pageNumber,
        size: this.pageSizeW
      };
      this.rowsDataWhite = [];
      if (pageNumber === 1) {
        this.totalRecordsW = 0;
      }
      this.loadingW = true;
      if (this.searchWhiteListEmail === null) {
        this.searchWhiteListEmail = '';
      }
      try {
        let respWhiteList = await PreferencesService.searchPreferences(
          this.$preference.ORG_WHITELIST,
          this.searchWhiteListEmail,
          paging
        );
        this.updateListData(respWhiteList);
      } catch (err) {
        this.loadingW = false;
        this.snackbar('error', err);
      }
    },
    // to remove whitelist item
    async removeItem() {
      try {
        await PreferencesService.removePreference(this.removeItemObj.id);
        if (
          this.rowsDataWhite.length === 1 &&
          Math.ceil(this.totalRecordsW / this.pageSizeW) === this.pageNumberW &&
          this.pageNumberW !== 1
        ) {
          this.pageNumberW--;
        }
        this.setPageW(this.pageNumberW);
        this.removeItemObj = null;
        this.snackbar('success', 'Deleted successfully');
        this.closeConfirmBox();
      } catch (err) {
        this.snackbar('error', err);
        this.closeConfirmBox();
      }
      //remove seected emails
    },
    // to get saved settings
    async getSettings() {
      try {
        let settingsResponse = await PreferencesService.getPreferencesByPreferenceKey(
          this.$preference.DOMAIN_WHITELIST_SETTINGS
        );
        let parsedResponse = this.parseResponse(settingsResponse);
        if (parsedResponse !== false) {
          this.validateWhiteList =
            parsedResponse[0].results[0].data.domainWhiteListSettings.WHITELIST_NEEDS_AUTH;
          this.enableUserWhiteList =
            parsedResponse[0].results[0].data.domainWhiteListSettings.USE_USER_WHITELIST;
          this.settingId = parsedResponse[0].results[0].id;
        } else {
          this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
        }
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    /**
     * to set confirm box data
     * @param {String} confirmFor
     * @param {Object} removeItem
     */
    openConfirmBox(confirmFor, removeItem) {
      this.confirmFor = confirmFor;
      this.dialogTitle = 'Please Confirm';
      if (confirmFor === 'save') {
        this.dialogText = 'Are you sure you want to save whitelist settings ?';
      } else {
        this.removeItemObj = removeItem;
        if (removeItem.metaData === 'domain') {
          this.dialogText = 'Are you sure you want to remove this domain ?';
        } else {
          this.dialogText = 'Are you sure you want to remove this email ?';
        }
      }
      this.cancelText = 'Cancel';
      this.successText = 'Yes';
      this.confirmDialogueVar = true;
    },
    // to update the settings
    async saveSetting() {
      let reqObject = this.preferenceServiceHelper.createPreferenceBody(
        'listSettings',
        {
          enableUserWhiteList: this.enableUserWhiteList,
          validateWhiteList: this.validateWhiteList
        },
        this.$preference.DOMAIN_WHITELIST_SETTINGS
      );
      let url = '';
      if (this.settingId === this.preferenceServiceHelper.defaultPreferenceId) {
        url = PreferencesService.addPreference(
          this.$preference.DOMAIN_WHITELIST_SETTINGS,
          reqObject
        );
      } else {
        url = PreferencesService.updatePreference(
          this.$preference.DOMAIN_WHITELIST_SETTINGS,
          this.settingId,
          reqObject
        );
      }
      try {
        let res = await url;
        let parsedResponse = this.parseResponse(res);
        if (parsedResponse !== false) {
          this.settingId = parsedResponse[0].id;
          this.enableUserBlackList =
            parsedResponse[0].data.domainWhiteListSettings.USE_USER_WHITELIST;
          this.validateBlackList =
            parsedResponse[0].data.domainWhiteListSettings.WHITELIST_NEEDS_AUTH;
          this.snackbar('success', this.$message.SAVED_SUCCESS);
        } else {
          this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
        }
        this.confirmDialogueVar = false;
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    // to close confirm box
    closeConfirmBox() {
      this.confirmDialogueVar = false;
    }
  },
  watch: {
    currentlySelectedOrgId: function() {
      this.getListData(true);
      this.getSettings();
    }
  }
};
</script>

<style scoped>
.wrap-text {
  word-break: break-all;
}

.v-input--checkbox .v-input__control .v-messages {
  display: none;
}
.v-input--checkbox .v-input__control .v-input__slot {
  margin-bottom: 0;
}
.legendHead {
  margin-top: 0px;
}
</style>
